export type WeaponMasteryOption = {
  readonly weaponKind: string;
  readonly label: string;
  readonly mastery: string;
  readonly category: "simple" | "martial";
};

export async function fetchWeaponMasteries(): Promise<WeaponMasteryOption[]> {
  const res = await fetch("/api/weapon-masteries");
  if (!res.ok) {
    throw new Error("Failed to fetch weapon mastery options");
  }
  return res.json() as Promise<WeaponMasteryOption[]>;
}
